// Listy pism autora — odwzorowanie Magistratu:
//   „Projekty pism"     — Documents.List.NormalProjectsList (pisma do przekazania do wysyłki),
//   „Wychodzące pisma"  — Documents.List.OutgoingDocumentsList (pismo → wygenerowane przesyłki,
//                          dopóki wszystkie nie zostaną wysłane).
// BE: OutgoingParcelController (api/outgoingParcel/letters/*).

/** DocumentInternalStatus z BE (numery zgodne z Magistratem). */
export enum EDocumentInternalStatus {
  Project = 0,
  GeneratedLetters = 4,
  ReadyToSign = 5,
  Sent = 7,
  ReadyToDispatch = 29,
  ReadyToDigitalSign = 30,
  SignedInternal = 31,
}

export interface ILetterProject {
  DocumentId: string;
  Title?: string | null;
  EncryptionKeyId?: string | null;
  CaseId?: string | null;
  CaseSignature?: string | null;
  CreationDate: string;
  LastModified?: string | null;
  InternalStatus: EDocumentInternalStatus;
  InternalStatusName?: string | null;
  HasSignedVersion: boolean;
  PendingSignerName?: string | null;
  ParcelsCount: number;
  MajorSignature?: string | null;
  Receivers?: string | null;
  /** Wygenerowane pisma do wydruku i podpisu odręcznego. */
  Parcels: ILetterProjectParcel[];
}

export interface ILetterProjectParcel {
  Id: string;
  ParcelNumber?: string | null;
  ReceiverName?: string | null;
  DeliveryKindName?: string | null;
}

export interface ILetterProjectsResponse {
  Items: ILetterProject[];
}

export interface IOutgoingLetterParcel {
  Id: string;
  ParcelNumber?: string | null;
  ReceiverName?: string | null;
  ReceiverAddress?: string | null;
  DeliveryKindId?: number | null;
  DeliveryKindName?: string | null;
  DeliveryKindIsElectronic: boolean;
  Stage: number;
  StageLabel?: string | null;
  IsSent: boolean;
  SendDate?: string | null;
  DispatchChartId?: string | null;
  DispatchChartSignature?: string | null;
  IsGrouped: boolean;
  HasSendError: boolean;
  /** Adresat ma w książce adresowej nowsze dane — przenosi je „Aktualizuj dane adresata”. */
  ReceiverDataOutdated?: boolean;
}

export interface IOutgoingLetter {
  DocumentId: string;
  Title?: string | null;
  EncryptionKeyId?: string | null;
  CaseId?: string | null;
  CaseSignature?: string | null;
  Date: string;
  MajorSignature?: string | null;
  Receivers?: string | null;
  SentCount: number;
  TotalCount: number;
  CanReturnToProject: boolean;
  Parcels: IOutgoingLetterParcel[];
}

export interface IOutgoingLettersResponse {
  Items: IOutgoingLetter[];
}

export interface IOfficialLettersActionRequest {
  DocumentIds: string[];
}

export interface IOfficialLettersActionResponse {
  Affected: number;
  Skipped: number;
  Message?: string | null;
}
